
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-modifier/-embroider-implicit-modules.js";
import "tracked-built-ins/-embroider-implicit-modules.js";
import "tracked-toolbox/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-gesture-modifiers/-embroider-implicit-modules.js";
import "ember-sinon/-embroider-implicit-modules.js";
